import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import validator from "validator";
import Swal from "sweetalert2";

export default function Modal({ productName, pdfDocUrl, handleSetBackdrop }) {
    const [email, setEmail] = useState("");
    const [token, setToken] = useState(null);
    const [isCaptchaExpired, setIsCaptchaExpired] = useState(false);
    const [isEmailError, setIsEmailError] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const captchaRef = useRef(null);

    useEffect(() => {
        if (isCaptchaExpired) setToken(null);
    }, [isCaptchaExpired]);

    const onSubmit = () => {
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify({
                email: email,
                productName: productName,
                pdfDocUrl: pdfDocUrl,
                title: "specification"
            })
        };
        setIsClicked(true);
        if (!validator.isEmail(email)) {
            setIsEmailError(true);
        } else {
            setIsEmailError(false);
        }

        if (validator.isEmail(email) && token) {
            handleSetBackdrop(true);
            fetch(`/api/products/send`, requestOptions)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setIsClicked(false);
                    setEmail("");
                    setToken(null);
                    handleSetBackdrop(false);
                    captchaRef.current.resetCaptcha();

                    if (result.status === "success") {
                        Swal.fire("Success!", result.msg, "success").then(
                            res => {
                                const closeBtn = document.getElementById(
                                    "closeModal"
                                );
                                const email = document.getElementById(
                                    "floatingInput"
                                );
                                email.value = "";
                                closeBtn.click();
                            }
                        );
                    } else {
                        Swal.fire("Oops...", result.msg, "error").then(res => {
                            const closeBtn = document.getElementById(
                                "closeModal"
                            );
                            const email = document.getElementById(
                                "floatingInput"
                            );
                            email.value = "";
                            closeBtn.click();
                        });
                    }
                });
        }
    };

    const handleVerificationSuccess = token => {
        setToken(token);
        if (token) setIsCaptchaExpired(false);
    };

    const closeModal = () => {
        // get modal
        const modal = document.getElementById("#exampleModal");

        // change state like in hidden modal
        modal.classList.remove("show");
        modal.setAttribute("aria-hidden", "true");
        modal.setAttribute("style", "display: none");

        // get modal backdrop
        const modalBackdrops = document.getElementsByClassName(
            "modal-backdrop"
        );

        // remove opened modal backdrop
        document.body.removeChild(modalBackdrops[0]);
    };

    return (
        <div
            className="modal fade"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            {productName} Specification
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <form
                            className="form-floating mb-3"
                            id="form"
                            noValidate
                        >
                            <input
                                name="email"
                                type="email"
                                className={`form-control ${
                                    isEmailError
                                        ? "is-invalid"
                                        : isClicked && "is-valid"
                                }`}
                                id="floatingInput"
                                placeholder="name@gmail.com"
                                defaultValue={email}
                                onChange={e => {
                                    setEmail(e.target.value);
                                }}
                            />
                            <label htmlFor="floatingInput">Email address</label>
                            {isEmailError ? (
                                <div className="invalid-feedback">
                                    Please enter a valid email.
                                </div>
                            ) : (
                                isClicked && (
                                    <div className="valid-feedback">
                                        Looks good!
                                    </div>
                                )
                            )}
                            <div className="mt-2">
                                <HCaptcha
                                    ref={captchaRef}
                                    sitekey="8d147cae-36a3-40e9-a9c5-6f5742ce5219"
                                    onVerify={token =>
                                        handleVerificationSuccess(token)
                                    }
                                    onExpire={() => setIsCaptchaExpired(true)}
                                />
                            </div>
                            {!token && isClicked ? (
                                <p className="text-danger">
                                    This is hCaptcha for human testing.
                                </p>
                            ) : (
                                isCaptchaExpired && (
                                    <p className="text-danger">
                                        The hCaptcha for human testing has
                                        expired.
                                    </p>
                                )
                            )}
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="submit"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                            id="closeModal"
                        >
                            Close
                        </button>
                        <button
                            onClick={onSubmit}
                            type="submit"
                            className="btn btn-dark"
                        >
                            Send
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
